export default __webpack_public_path__ + "6cc611948bc3073164fb6733db4f9f25.gif";